export default abstract class PagamentoRoutes {
  static readonly PAGAMENTO: string = '/pagamentos'
  static readonly TRANSFERENCIA: string = '/pagamentos/transferencia'
  static readonly PORCENTAGEM_TRANSFERENCIA: string =
    '/pagamentos/porcentagem-transferencia'

  static readonly CONFIRMACAO: string = '/pagamentos/confirmacao'
  static readonly EXTRATO: string = '/pagamentos/extrato'
  static readonly PAGAMENTO_BOLETO: string = '/pagamentos/pagar-boleto'
  static readonly INSTRUCOES: string = '/tmov-pay-instructions'
  static readonly TRAZER_DINHEIRO: string = '/pagamentos/trazer-dinheiro'
  static readonly COMPROVANTE: string = '/pagamentos/comprovante'
  static readonly ONBOARDING: string = '/pagamentos/onboarding'
}
